import {
  KEEPALIVE_SIGNALS_REQUEST,
  KEEPALIVE_SIGNALS_SUCCESS,
  KEEPALIVE_SIGNALS_FAILURE
} from '../actions/keepalivesignals'

const INITIAL_STATE = {
  signals: null,
  error: null,
  loading: false
}

const keepAliveSignalsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case KEEPALIVE_SIGNALS_REQUEST:
      return { ...state, error: null, loading: true }
    case KEEPALIVE_SIGNALS_SUCCESS:
      return { ...state, signals: action.response, error: null, loading: false }
    case KEEPALIVE_SIGNALS_FAILURE:
      return { ...state, error: action.error, loading: false }
    default:
      return state
  }
}

export default keepAliveSignalsReducer
